<div
  [id]="id"
  class="sgt-table__container"
  [class.sgt-table__container--empty]="settings?.isEmpty"
  [ngClass]="settings?.customContainerClass"
  (scroll)="onScroll($event)"
  *ngIf="settings && !settings.loading"
>
  <table class="sgt-table" [ngClass]="settings?.customTableClass">
    <thead class="sgt-table__header sgt-table__header--fixed">
      <ng-content select="[header]"></ng-content>
    </thead>
    <tbody [ngClass]="settings?.customRowClass">
      <ng-content select="[body]"></ng-content>
      <ng-content select="[empty]" *ngIf="settings?.isEmpty"></ng-content>
    </tbody>
    <tfoot
      *ngIf="settings?.showFooter"
      class="sgt-table__footer sgt-table__footer--fixed"
    >
      <ng-content select="[footer]"></ng-content>
    </tfoot>
  </table>
</div>

<ng-container *ngIf="settings?.showDisplayCounterRecords">
  <div
    class="sgt-table__info"
    *ngIf="settings && settings.itensPerPage && settings.totalItens"
  >
    Mostrando {{ settings?.itensPerPage }} de {{ settings?.totalItens }}
  </div>
</ng-container>
